module.exports = __webpack_public_path__ + "img/logo.74030373.png";